export const MEDIA_SIZES = {
  SMALL_LOGO: 'small_logo',
  SQUARE: 'square',
  ORIGINAL: 'original',
  MEDIUM: 'medium',
  THUMBNAIL: 'thumbnail',
  LARGE: 'large',
  BANNER: 'banner',
  CUSTOM: 'custom',
};

export const ENTITIES_TYPE = {
  COMMENT: 'COMMENT',
  COMPANY_BANNER: 'COMPANY_BANNER',
  COMPANY_LOGO: 'COMPANY_LOGO',
  CONVERSATION: 'CONVERSATION',
  GROUP_COVER_PHOTO: 'GROUP_COVER_PHOTO',
  ORGANIZATION_HIRING_EVENT: 'ORGANIZATION_HIRING_EVENT',
  ORGANIZATION_HUB: 'ORGANIZATION_HUB',
  ORGANIZATION_JOB: 'ORGANIZATION_JOB',
  PROFILE_PHOTO: 'PROFILE_PHOTO',
  ROUNDUP: 'ROUNDUP',
  STATIC: 'STATIC',
  TOPIC_COVER_PHOTO: 'TOPIC_COVER_PHOTO',
  PROMOTIONAL: 'PROMOTIONAL',
};

export default {
  MEDIA_SIZES,
  ENTITIES_TYPE,
};
